/* import __COLOCATED_TEMPLATE__ from './plc-hardware.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();